/**
 * 配置中心接口
 */
export default {
  // 应用中心字典配置查询
  pes_dicConfigData: {
    // mock: true,
    control: 'dyc/saas/common/communal/dicConfig/queryData'
  },
  // 应用中心字典配置修改
  pes_operateData: {
    // mock: true,
    control: 'dyc/common/communal/dicConfig/operateData'
  },
  // 字典配置查询
  pes_dictionaryData: {
    // mock: true,
    control: 'dyc/sassnogateway/saas/common/user/queryData'
  },
  // 字典配置修改
  pes_dictionaryOperateData: {
    // mock: true,
    control: 'dyc/common/communal/dictionary/operateData'
  },
  // redis刷新
  pes_refreshData: {
    // mock: true,
    control: 'dyc/common/communal/dictionary/refreshData'
  },
  // 配置中心-参数设置-商品管理参数- 商品电商默认加价系数 - 添加例外 - 应用第三方名称下拉数据
  common_queryGoodsSupplierforDrop: {
    // mock: true,
    control: 'dyc/supplier/queryGoodsSupplierforDrop'
  },
  // 配置中心-参数设置-商品管理参数- 商品电商默认加价系数 - 新增添加例外
  common_dealDycUccConfigurationparametersAdd: {
    // mock: true,
    control: 'dyc/busicommon/commodity/dealDycUccConfigurationparametersAdd'
  },
  // 配置中心-参数设置-商品管理参数- 商品电商默认加价系数 -删除
  common_deleteparametersQry: {
    // mock: true,
    control: 'dyc/busicommon/commodity/deleteparametersQry'
  },
  // 配置中心-参数设置-公共参数左侧列表
  common_qryPesDicListPage: {
    // mock: true,
    control: 'dyc/common/user/dic/qryPesDicListPage'
  },
  // 配置中心-参数设置-公共参数-收藏个数列表
  common_qryOpdcCollectionShopMaxListPage: {
    // mock: true,
    control: 'dyc/saas/common/user/qryCollectionShopMax'
  },
  // 配置中心-参数设置-公共参数-收藏个数列表维护
  common_dealOpdcCollectionShopMax: {
    // mock: true,
    control: 'dyc/saas/common/user/dealOpdcCollectionShopMax'
  },
  // 配置中心-参数设置-公共参数-京东PIN列表
  common_qryOpdcJdPINListPage: {
    // mock: true,
    control: 'dyc/saas/common/user/dic/qryOpdcJdPINListPage'
  },
  // 配置中心-参数设置-公共参数-京东PIN列表维护
  common_dealOpdcJdPIN: {
    // mock: true,
    control: 'dyc/common/user/dic/dealOpdcJdPIN'
  },
  // 配置中心-参数设置-公共参数-平台模块启用设置
  common_queryPlatformEnablePara: {
    // mock: true,
    control: 'dyc/config/cfc/queryPlatformEnablePara'
  },
  // 配置中心-参数设置-公共参数-附件上传规则设置
  common_qryAccessUploadListPage: {
    // mock: true,
    control: 'dyc/config/cfc/unite/qryAccessUploadListPage'
  },
  // 配置中心-参数设置-公共参数-附件上传规则设置-修改附件上传规则设置-平台模块下拉
  common_qryFunctionModuleList: {
    // mock: true,
    control: 'dyc/common/user/module/qryFunctionModuleList'
  },
  // 配置中心-参数设置-公共参数-附件上传规则设置-添加例外
  common_addAccessUpload: {
    // mock: true,
    control: 'dyc/config/cfc/unite/addAccessUpload'
  },
  // 配置中心-参数设置-公共参数-附件上传规则设置-删除例外
  common_delUniteParam: {
    // mock: true,
    control: 'dyc/config/cfc/unite/delUniteParam'
  },
  // 配置中心-参数设置-公共参数-附件上传规则设置-修改例外
  common_updateAccessUpload: {
    // mock: true,
    control: 'dyc/config/cfc/unite/updateAccessUpload'
  },
  // 配置中心-参数设置-公共参数-外部系统对接情况设置
  common_qryExtSystemListPage: {
    // mock: true,
    control: 'dyc/config/cfc/unite/qryExtSystemListPage'
  },
  // 配置中心-参数设置-公共参数-外部系统对接情况设置修改
  common_updateExtSystemBatch: {
    // mock: true,
    control: 'dyc/config/cfc/unite/updateExtSystemBatch'
  },
  // 配置中心-参数设置-公共参数-审批流程所在系统情况设置
  common_qryApprovalSystemListPage: {
    // mock: true,
    control: 'dyc/config/cfc/unite/qryApprovalSystemListPage'
  },
  // 配置中心-参数设置-公共参数-审批流程所在系统情况设置-添加例外采购单位下拉
  common_qryPurchaseDropDwonList: {
    // mock: true,
    control: 'dyc/saas/common/user/org/qryPurchaseDropDwonList'
  },
  // 配置中心-参数设置-公共参数-审批流程所在系统情况设置-添加例外
  common_addApprovalSystem: {
    // mock: true,
    control: 'dyc/config/cfc/unite/addApprovalSystem'
  },
  // 配置中心-参数设置-公共参数-审批流程所在系统情况设置-修改
  common_updateApprovalSystem: {
    // mock: true,
    control: 'dyc/config/cfc/unite/updateApprovalSystem'
  },
  // 配置中心-参数设置-支付结算参数-结算单（订单）编号
  common_qryEncodedRuleListPage: {
    // mock: true,
    control: 'dyc/config/cfc/qryEncodedRuleListPage'
  },
  // 配置中心-配置表管理-结算单（其他）编号-删除
  common_dealEncodedRule: {
    // mock: true,
    control: 'dyc/config/cfc/dealEncodedRule'
  },
  // 配置中心-配置表管理-机构类型配置列表
  common_qryOrgTypeConfigListPage: {
    // mock: true,
    control: 'dyc/saas/common/orgType/qryOrgTypeConfigListPage'
  },
  // 配置中心-配置表管理-机构类型配置列表维护-新增、修改、删除
  common_dealOrgTypeConfig: {
    // mock: true,
    control: 'dyc/saas/common/orgType/dealOrgTypeConfig'
  },
  // 配置中心-配置表管理-机构类型配置列表维护-新增、修改、删除
  common_deleteOrgType: {
    // mock: true,
    control: 'dyc/saas/common/orgType/deleteOrgType'
  },
  // 配置中心-基本规则设置-参数详情查询
  common_qryParamConfigDetail: {
    // mock: true,
    control: 'dyc/config/cfc/qryParamConfigDetail'
  },
  // 配置中心-基本规则设置-参数详情保存
  common_dealParamConfig: {
    // mock: true,
    control: 'dyc/config/cfc/dealParamConfig'
  },
  // 配置中心-编码规则新增
  common_addEncodedRule: {
    // mock: true,
    control: 'dyc/config/cfc/addEncodedRule'
  },
  // 配置中心-配置表管理-机构类型配置机构
  common_qryOrgTypeConfigChoose: {
    // mock: true,
    control: 'dyc/saas/common/orgType/qryOrgTypeConfigChoose'
  },
  // 配置中心-参数设置-订单管理参数-差异化验收配置
  common_queryInsConfList: {
    // mock: true,
    control: 'dyc/self/order/queryInspectionConfigUse'
  },
  // 配置中心-参数设置-订单管理参数-差异化验收配置-修改统一设置查询
  common_qryConfig: {
    // mock: true,
    control: 'dyc/self/order/qryInspectionConfig'
  },
  // 配置中心-参数设置-订单管理参数-差异化验收配置-修改统一设置保存
  common_saveConfig: {
    // mock: true,
    control: 'dyc/self/order/saveInspectionConfig'
  },
  // 配置中心-参数设置-订单管理参数-订单编号详情
  common_qryEncodedRuleListDetailed: {
    // mock: true,
    control: 'dyc/config/cfc/qryEncodedRuleListDetailed'
  },
  // 配置中心-参数设置-订单管理参数-保存
  common_updateEncodedRule: {
    // mock: true,
    control: 'dyc/config/cfc/updateEncodedRule'
  },
  // 配置中心-参数设置-订单管理参数-保存
  common_addEncodedRuleException: {
    // mock: true,
    control: 'dyc/config/cfc/addEncodedRuleException'
  },
  // 配置中心-参数设置-订单管理参数-订单时限设置搜索
  common_queryOrderEffectivePage: {
    // mock: true,
    control: 'dyc/self/order/queryOrderEffectivePage'
  },
  // 配置中心-参数设置-订单管理参数-订单时限设置-修改
  common_updateOrderEffective: {
    // mock: true,
    control: 'dyc/self/order/updateOrderEffective'
  },
  // 配置中心-参数设置-订单管理参数-订单时限设置-添加例外
  common_addOrderEffective: {
    // mock: true,
    control: 'dyc/self/order/addOrderEffective'
  },
  // 配置中心-参数设置-订单管理参数-订单时限设置-删除
  common_deleteOrderEffective: {
    // mock: true,
    control: 'dyc/self/order/deleteOrderEffective'
  },
  // 配置中心-参数设置-订单管理参数-下单限额配置
  common_queryOrderQuotaAllocationPage: {
    // mock: true,
    control: 'dyc/self/order/queryOrderQuotaAllocationPage'
  },
  // 配置中心-参数设置-订单管理参数-下单限额配置-新增
  common_addOrderQuotaAllocation: {
    // mock: true,
    control: 'dyc/self/order/addOrderQuotaAllocation'
  },
  // 配置中心-参数设置-订单管理参数-下单限额配置-新增
  common_updateOrderQuotaAllocation: {
    // mock: true,
    control: 'dyc/self/order/updateOrderQuotaAllocation'
  },
  // 配置中心-参数设置-订单管理参数-下单限额配置-删除
  common_deleteOrderQuotaAllocation: {
    // mock: true,
    control: 'dyc/self/order/deleteOrderQuotaAllocation'
  },
  // 配置中心-参数设置-订单管理参数-订单评价配置
  common_queryOrderEvaluatePage: {
    // mock: true,
    control: 'dyc/self/order/queryOrderEvaluatePage'
  },
  // 配置中心-参数设置-订单管理参数-订单评价配置-修改
  common_updateOrderEvaluate: {
    // mock: true,
    control: 'dyc/self/order/updateOrderEvaluate'
  },
  // 配置中心-参数设置-订单管理参数-订单评价配置-保存
  common_addOrderEvaluate: {
    // mock: true,
    control: 'dyc/self/order/addOrderEvaluate'
  },
  // 配置中心-参数设置-订单管理参数-订单评价配置-删除
  common_deleteOrderEvaluate: {
    // mock: true,
    control: 'dyc/self/order/deleteOrderEvaluate'
  },
  // 配置中心-参数设置-订单管理参数-订单按钮配置
  common_queryOrderButtonSettings: {
    // mock: true,
    control: 'dyc/self/order/queryOrderButtonSettings'
  },
  // 配置中心-参数设置-订单管理参数-售后期限配置查询
  common_queryUocConfAfterOverdue: {
    // mock: true,
    control: 'dyc/self/order/queryUocConfAfterOverdue'
  },
  // 配置中心-参数设置-订单管理参数-售后期限配置查询
  common_modifyConfAfterOverdue: {
    // mock: true,
    control: 'dyc/self/order/modifyConfAfterOverdue'
  },
  // 配置中心-参数设置-订单管理参数-订单按钮配置-更新
  common_editOrderButtonSettings: {
    // mock: true,
    control: 'dyc/self/order/editOrderButtonSettings'
  },
  // 配置中心-参数设置-支付结算参数-结算单（订单）发票签收校验字段列表
  common_qryInvoiceCheckListPage: {
    // mock: true,
    control: 'dyc/config/cfc/unite/qryInvoiceCheckListPage'
  },
  // 配置中心-参数设置-支付结算参数-结算单（订单）发票签收校验字段详情查询
  common_qryInvoiceCheckDetail: {
    // mock: true,
    control: 'dyc/config/cfc/unite/qryInvoiceCheckDetail'
  },
  // 配置中心-参数设置-支付结算参数-结算单（订单）发票签收校验字段详情查询-添加例外
  common_addInvoiceCheck: {
    // mock: true,
    control: 'dyc/config/cfc/unite/addInvoiceCheck'
  },
  // 配置中心-参数设置-支付结算参数-结算单（订单）发票签收校验字段详情查询-修改
  common_updateInvoiceCheck: {
    // mock: true,
    control: 'dyc/config/cfc/unite/updateInvoiceCheck'
  },
  // 配置中心-参数设置-支付结算参数-结算单（订单）运营单位反馈规则列表
  common_qryFeedbackRuleListPage: {
    // mock: true,
    control: 'dyc/config/cfc/unite/qryFeedbackRuleListPage'
  },
  // 配置中心-参数设置-支付结算参数-结算单（订单）运营单位反馈规则-修改
  common_updateFeedbackRule: {
    // mock: true,
    control: 'dyc/config/cfc/unite/updateFeedbackRule'
  },
  // 配置中心-参数设置-支付结算参数-供应商回传/上传发票是否需要明细数据
  common_qryInvoiceUploadDetailsListPage: {
    // mock: true,
    control: 'dyc/config/cfc/unite/qryInvoiceUploadDetailsListPage'
  },
  // 配置中心-参数设置-支付结算参数-供应商回传/上传发票是否需要明细数据-修改
  common_updateInvoiceUploadDetails: {
    // mock: true,
    control: 'dyc/config/cfc/unite/updateInvoiceUploadDetails'
  },
  // 配置中心-参数设置-支付结算参数-结算单（订单）对账渠道&方式列表查询
  common_qryReconciliationChannelListPage: {
    // mock: true,
    control: 'dyc/config/cfc/unite/qryReconciliationChannelListPage'
  },
  // 配置中心-参数设置-支付结算参数-结算单（订单）对账渠道&方式-添加例外
  common_addReconciliationChannel: {
    // mock: true,
    control: 'dyc/config/cfc/unite/addReconciliationChannel'
  },
  // 配置中心-参数设置-支付结算参数-结算单（订单）对账渠道&方式-修改
  common_updateReconciliationChannel: {
    // mock: true,
    control: 'dyc/config/cfc/unite/updateReconciliationChannel'
  },
  // 配置中心-参数设置-支付结算参数-是否允许上游未签收发票下游进行结算列表查询
  common_qryIndividualSettleListPage: {
    // mock: true,
    control: 'dyc/config/cfc/unite/qryIndividualSettleListPage'
  },
  // 配置中心-参数设置-支付结算参数-是否允许上游未签收发票下游进行结算-添加例外
  common_addIndividualSettle: {
    // mock: true,
    control: 'dyc/config/cfc/unite/addIndividualSettle'
  },
  // 配置中心-参数设置-支付结算参数-是否允许上游未签收发票下游进行结算-修改
  common_updateIndividualSettle: {
    // mock: true,
    control: 'dyc/config/cfc/unite/updateIndividualSettle'
  },
  // 配置中心-参数设置-支付结算参数-采购单位/供应商接收运营发票是否需要签收列表查询
  common_qryOperInvoiceSignListPage: {
    // mock: true,
    control: 'dyc/config/cfc/unite/qryOperInvoiceSignListPage'
  },
  // 配置中心-参数设置-支付结算参数-采购单位/供应商接收运营发票是否需要签收-修改
  common_updateOperInvoiceSign: {
    // mock: true,
    control: 'dyc/config/cfc/unite/updateOperInvoiceSign'
  },
  // 配置中心-参数设置-支付结算参数-采购单位/供应商接收运营发票是否需要签收-添加例外
  common_addOperInvoiceSign: {
    // mock: true,
    control: 'dyc/config/cfc/unite/addOperInvoiceSign'
  },
  // 配置中心-参数设置-支付结算参数-采购单位/支付结算单据发起权限和处理权限
  common_qryBillAuthListPage: {
    // mock: true,
    control: 'dyc/config/cfc/unite/qryBillAuthListPage'
  },
  // 配置中心-参数设置-支付结算参数-运营单位发票邮寄的发票打捆规则列表查询
  common_qryInvoiceBundlingListPage: {
    // mock: true,
    control: 'dyc/config/cfc/unite/qryInvoiceBundlingListPage'
  },
  // 配置中心-参数设置-支付结算参数-运营单位发票邮寄的发票打捆规则-修改
  common_updateInvoiceBundling: {
    // mock: true,
    control: 'dyc/config/cfc/unite/updateInvoiceBundling'
  },
  // 配置中心-参数设置-支付结算参数-运营单位发票邮寄的发票打捆规则列表查询-添加例外
  common_addBillAuth: {
    // mock: true,
    control: 'dyc/config/cfc/unite/addBillAuth'
  },
  // 配置中心-参数设置-支付结算参数-运营单位发票邮寄的发票打捆规则列表查询-修改
  common_updateBillAuth: {
    // mock: true,
    control: 'dyc/config/cfc/unite/updateBillAuth'
  },
  // 配置中心-参数设置-支付结算参数-协议支付结算可选规则列表查询
  common_qryAgrSettleOptionalListPage: {
    // mock: true,
    control: 'dyc/config/cfc/unite/qryAgrSettleOptionalListPage'
  },
  // 配置中心-参数设置-支付结算参数-协议支付结算可选规则列表-详情查询
  common_qryAgrSettleOptionalDetail: {
    // mock: true,
    control: 'dyc/config/cfc/unite/qryAgrSettleOptionalDetail'
  },
  // 配置中心-参数设置-支付结算参数-协议支付结算可选规则-修改
  common_updateAgrSettleOptional: {
    // mock: true,
    control: 'dyc/config/cfc/unite/updateAgrSettleOptional'
  },
  // 配置中心-参数设置-支付结算参数-收款单位订单账期逾期天数计算标准
  common_qryAccountOverdueDayListPage: {
    // mock: true,
    control: 'dyc/config/cfc/unite/qryAccountOverdueDayListPage'
  },
  // 配置中心-参数设置-支付结算参数-收款单位订单账期逾期天数计算标准-修改
  common_updateAccountOverdueDay: {
    // mock: true,
    control: 'dyc/config/cfc/unite/updateAccountOverdueDay'
  },
  // 配置中心-参数设置-支付结算参数-结算单（订单）拆分条件限制列表查询
  common_qryOrderSplitConditonListPage: {
    // mock: true,
    control: 'dyc/config/cfc/unite/qryOrderSplitConditonListPage'
  },
  // 配置中心-参数设置-支付结算参数-结算单（订单）拆分条件-添加例外
  common_addOrderSplitConditon: {
    // mock: true,
    control: 'dyc/config/cfc/unite/addOrderSplitConditon'
  },
  // 配置中心-参数设置-支付结算参数-结算单（订单）拆分条件-修改
  common_updateOrderSplitConditon: {
    // mock: true,
    control: 'dyc/config/cfc/unite/updateOrderSplitConditon'
  },
  // 配置中心-参数设置-支付结算参数-结算单（订单）详情页面挂起功能是否启用列表查询
  common_qryOrderDetailMountListPage: {
    // mock: true,
    control: 'dyc/config/cfc/unite/qryOrderDetailMountListPage'
  },
  // 配置中心-参数设置-支付结算参数-结算单（订单）详情页面挂起功能是否启用列表查询-修改
  common_updateOrderDetailMount: {
    // mock: true,
    control: 'dyc/config/cfc/unite/updateOrderDetailMount'
  },
  // 配置中心-参数设置-支付结算参数-运营单位是否允许代采购单位发起下游结算单列表查询
  common_qryAgentPurDownSettleListPage: {
    // mock: true,
    control: 'dyc/config/cfc/unite/qryAgentPurDownSettleListPage'
  },
  // 配置中心-参数设置-支付结算参数-运营单位是否允许代采购单位发起下游结算单-修改
  common_updateAgentPurDownSettle: {
    // mock: true,
    control: 'dyc/config/cfc/unite/updateAgentPurDownSettle'
  },
  // 配置中心-参数设置-支付结算参数-支付结算金额保留位数和规则列表查询
  common_qrySettleMoneyDigitListPage: {
    // mock: true,
    control: 'dyc/config/cfc/unite/qrySettleMoneyDigitListPage'
  },
  // 配置中心-参数设置-支付结算参数-支付结算金额保留位数和规则-添加例外
  common_addSettleMoneyDigit: {
    // mock: true,
    control: 'dyc/config/cfc/unite/addSettleMoneyDigit'
  },
  // 配置中心-参数设置-支付结算参数-支付结算金额保留位数和规则-修改
  common_updateSettleMoneyDigit: {
    // mock: true,
    control: 'dyc/config/cfc/unite/updateSettleMoneyDigit'
  },
  // 配置中心-参数设置-支付结算参数-外部个人用户订单可开具发票时限列表查询
  common_qryExtPersonBillingTimeListPage: {
    // mock: true,
    control: 'dyc/config/cfc/unite/qryExtPersonBillingTimeListPage'
  },
  // 配置中心-参数设置-支付结算参数-外部个人用户订单可开具发票时限-修改
  common_updateExtPersonBillingTime: {
    // mock: true,
    control: 'dyc/config/cfc/unite/updateExtPersonBillingTime'
  },
  // 配置中心-岗位管理-列表搜索查询
  rest_selectStationPage: {
    // mock: true,
    control: 'dyc/saas/common/user/author/station/new/selectStationPage'
  },
  // 配置中心-岗位管理-保存
  rest_saveStation: {
    // mock: true,
    control: 'dyc/common/user/author/station/new/saveStation'
  },
  // 配置中心-岗位管理-详情
  rest_stationSelectById: {
    // mock: true,
    control: 'dyc/common/user/author/station/new/stationSelectById'
  },
  // 配置中心-岗位管理-停启用
  rest_updateStatusStation: {
    // mock: true,
    control: 'dyc/common/user/author/station/new/UpdateStatusStation'
  },
  // 配置中心-岗位管理-删除
  rest_deleteStation: {
    // mock: true,
    control: 'dyc/common/user/author/station/new//deleteStation'
  },
  // 配置中心-岗位管理-数据权限设置-列表查询
  rest_selectStationConfigPage: {
    // mock: true,
    control: 'dyc/common/user/author/stationConfig/selectStationConfigPage'
  },
  // 配置中心-岗位管理-数据权限设置-新增
  rest_savedStationConfigSave: {
    // mock: true,
    control: 'dyc/common/user/author/stationConfig/savedStationConfigSave'
  },
  // 配置中心-岗位管理-数据权限设置-删除
  rest_deleteStationConfig: {
    // mock: true,
    control: 'dyc/common/user/author/stationConfig/deleteStationConfig'
  },
  // 配置中心-数据权限类型配置-保存
  rest_saveStationBusiness: {
    // mock: true,
    control: 'dyc/common/user/author/stationBusiness/saveStationBusiness'
  },
  // 配置中心-数据资源类型-分页搜索列表查询
  rest_selectSourcePage: {
    // mock: true,
    control: 'dyc/saas/common/user/author/stationSource/selectSourcePage'
  },
  // 配置中心-数据资源类型-删除
  rest_delete: {
    // mock: true,
    control: 'dyc/common/user/author/stationSource/delete'
  },
  // 配置中心-数据资源类型-保存
  rest_save: {
    // mock: true,
    control: 'dyc/common/user/author/stationSource/save'
  },
  // 配置中心-数据资源类型-详情查询
  rest_selectStationBusiness: {
    // mock: true,
    control: 'dyc/common/user/author/stationSource/selectStationBusiness'
  },
  // 配置中心-数据权限管理-数据权限类型配置
  rest_selectStationBusinessPage: {
    // mock: true,
    control: 'dyc/saas/common/user/author/stationBusiness/selectStationBusinessPage'
  },
  // 配置中心-数据资源类型配置-应用模块功能列表
  rest_qryStationBusinessFunctionModuleList: {
    // mock: true,
    control: 'dyc/saas/common/user/author/stationBusiness/qryStationBusinessFunctionModuleList'
  },
  // 配置中心-数据权限类型配置-删除
  rest_deleteStationBusines: {
    // mock: true,
    control: 'dyc/common/user/author/stationBusiness/deleteStationBusines'
  },
  // 配置中心-工作日设置-节假日查询
  common_qryWeekDayConfigList: {
    // mock: true,
    control: 'dyc/saas/common/weekdayConfig/qryWeekDayConfigList'
  },
  // 配置中心-工作日设置-节假日设置
  common_saveWeekDayConfigBatch: {
    // mock: true,
    control: 'dyc/saas/common/weekdayConfig/saveWeekDayConfigBatch'
  },
  // 数据权限类型配置-详情查询
  rest_selectStationBusinessNew: {
    // mock: true,
    control: 'dyc/common/user/author/stationBusiness/selectStationBusinessNew'
  },
  // 菜单管理-查询菜单目录
  rest_selectCatalogTree: {
    // mock: true,
    control: 'dyc/common/user/author/menu/selectCatalogTree'
  },
  // 菜单管理-查询菜单详情
  rest_selectByMenuId: {
    // mock: true,
    control: 'dyc/common/user/author/menu/selectByMenuId'
  },
  // 菜单管理-一级菜单新增
  rest_addCatalog: {
    // mock: true,
    control: 'dyc/common/user/author/menu/addCatalog'
  },
  // 菜单管理-删除
  rest_deleteMenu: {
    // mock: true,
    control: 'dyc/common/user/author/menu/delete'
  },
  // 菜单管理-菜单目录
  configure_getMenuList: {
    // mock: true,
    control: '/dyc/saas/common/menu/getMenuList'
  },
  // 菜单管理-菜单域名下拉框
  configure_getMenuDomainList: {
    // mock: true,
    control: '/dyc/saas/common/menu/getMenuDomainList'
  },
  // 菜单管理-新增菜单
  configure_createMenu: {
    // mock: true,
    control: '/dyc/saas/common/menu/createMenu'
  },
  // 菜单管理-编辑菜单
  configure_modifyMenu: {
    // mock: true,
    control: '/dyc/saas/common/menu/modifyMenu'
  },
  // 菜单管理-删除菜单
  configure_deleteMenu: {
    // mock: true,
    control: '/dyc/saas/common/menu/deleteMenu'
  },
  // 菜单管理-启用
  configure_enableMenu: {
    // mock: true,
    control: '/dyc/saas/common/menu/enableMenu'
  },
  // 菜单管理-停用
  configure_disableMenu: {
    // mock: true,
    control: '/dyc/saas/common/menu/disableMenu'
  },
  // 菜单管理-详情
  configure_getMenuDetail: {
    // mock: true,
    control: '/dyc/saas/common/menu/getMenuDetail'
  },
  // 子页面管理-列表
  configure_getSubpageList: {
    // mock: true,
    control: '/dyc/saas/common/subpage/getSubpageList'
  },
  // 子页面管理-子页面类型接口
  configure_querySubpageType: {
    // mock: true,
    control: '/dyc/saas/common/subpage/querySubpageType'
  },
  // 子页面管理-新增子页面
  configure_createSubpage: {
    // mock: true,
    control: '/dyc/saas/common/subpage/createSubpage'
  },
  // 子页面管理-修改子页面
  configure_modifySubpage: {
    // mock: true,
    control: '/dyc/saas/common/subpage/modifySubpage'
  },
  // 子页面管理-查询子页面已绑定菜单
  configure_queryBindSubList: {
    // mock: true,
    control: '/dyc/saas/common/subpage/queryBindSubList'
  },
  // 子页面管理-子页面绑定菜单
  configure_bindMenu: {
    // mock: true,
    control: '/dyc/saas/common/subpage/bindMenu'
  },
  // 菜单管理-菜单状态变更
  rest_changeStatus: {
    // mock: true,
    control: 'dyc/common/user/author/menu/changeStatus'
  },
  // 菜单管理-新增子级菜单
  rest_addSublevelMenu: {
    // mock: true,
    control: 'dyc/common/user/author/menu/addSublevelMenu'
  },
  // 菜单管理-修改菜单信息
  rest_update: {
    // mock: true,
    control: 'dyc/common/user/author/menu/update'
  },
  // 菜单管理-常用功能菜单图标
  rest_query: {
    // mock: true,
    control: 'dyc/common/user/author/dic/query'
  },
  // 菜单管理-排序-下降
  rest_down: {
    // mock: true,
    control: 'dyc/common/user/author/menu/down'
  },
  // 菜单管理--排序-上升
  rest_up: {
    // mock: true,
    control: 'dyc/common/user/author/menu/up'
  },
  // 文件模板分页查询
  fileDownloadPlatform_list: {
    // mock: true,
    control: 'fileDownloadPlatform/fileTemplate/list'
  },
  // 文件模板新增
  fileDownloadPlatform_add: {
    // mock: true,
    control: 'fileDownloadPlatform/fileTemplate/add'
  },
  // 文件模板修改
  fileDownloadPlatform_update: {
    // mock: true,
    control: 'fileDownloadPlatform/fileTemplate/update'
  },
  // 文件模板详情查询
  fileDownloadPlatform_detail: {
    // mock: true,
    control: 'fileDownloadPlatform/fileTemplate/detail'
  },
  // 文件模板删除
  fileDownloadPlatform_delete: {
    // mock: true,
    control: 'fileDownloadPlatform/fileTemplate/delete'
  },
  // 服务管理分页查询
  fileDownloadPlatform_serviceList: {
    // mock: true,
    control: 'fileDownloadPlatform/serviceDefine/list'
  },
  // 服务管理新增
  fileDownloadPlatform_serviceAdd: {
    // mock: true,
    control: 'fileDownloadPlatform/serviceDefine/add'
  },
  // 服务管理修改
  fileDownloadPlatform_serviceUpdate: {
    // mock: true,
    control: 'fileDownloadPlatform/serviceDefine/update'
  },
  // 服务管理详情
  fileDownloadPlatform_serviceDetail: {
    // mock: true,
    control: 'fileDownloadPlatform/serviceDefine/detail'
  },
  // 服务管理删除
  fileDownloadPlatform_serviceDelete: {
    // mock: true,
    control: 'fileDownloadPlatform/serviceDefine/delete'
  },
  // 功能管理分页查询
  fileDownloadPlatform_functionList: {
    // mock: true,
    control: 'fileDownloadPlatform/functionDefine/list'
  },
  // 功能管理新增
  fileDownloadPlatform_functionAdd: {
    // mock: true,
    control: 'fileDownloadPlatform/functionDefine/add'
  },
  // 功能管理修改
  fileDownloadPlatform_functionUpdate: {
    // mock: true,
    control: 'fileDownloadPlatform/functionDefine/update'
  },
  // 功能管理详情
  fileDownloadPlatform_functionDetail: {
    // mock: true,
    control: 'fileDownloadPlatform/functionDefine/detail'
  },
  // 功能管理删除
  fileDownloadPlatform_functionDelete: {
    // mock: true,
    control: 'fileDownloadPlatform/functionDefine/delete'
  },
  // 功能管理文件模板下拉列表
  fileDownloadPlatform_functionFileTemplatelist: {
    // mock: true,
    control: 'fileDownloadPlatform/fileTemplate/select/list'
  },
  // 功能管理服务管理下拉列表
  fileDownloadPlatform_functionServiceDefinelist: {
    // mock: true,
    control: 'fileDownloadPlatform/serviceDefine/select/list'
  },
  // 功能管理服务管理-下载任务提交
  fileDownloadPlatform_download: {
    // mock: true,
    control: 'fileDownloadPlatform/task/commit'
  },
  // 公用应用-返回信息修改
  common_operRspInfo: {
    // mock: true,
    control: 'dyc/config/cfc/unite/operRspInfo'
  },
  // 公用应用-缴费周期列表
  common_qryPayCycleListPage: {
    // mock: true,
    control: 'dyc/config/cfc/qryPayCycleListPage'
  },
  // 公用应用-缴费周期新增
  common_addPayCycle: {
    // mock: true,
    control: 'dyc/config/cfc/addPayCycle'
  },
  // 公用应用-缴费周期修改
  common_UpdatePayCycle: {
    // mock: true,
    control: 'dyc/config/cfc/updatePayCycle'
  },
  // 公用应用-缴费周期详情
  common_qryPayCycleDetail: {
    // mock: true,
    control: 'dyc/config/cfc/qryPayCycleDetail'
  },
  // 公用应用-缴费周期删除
  common_dealPayCycle: {
    // mock: true,
    control: 'dyc/config/cfc/dealPayCycle'
  },
  // 公用应用-导入模版列表查询API
  common_qryImportTemplateList: {
    // mock: true,
    control: 'dyc/config/cfc/unite/qryImportTemplateList'
  },
  // 公用应用-导入模版删除API
  common_deleteImportTemplate: {
    // mock: true,
    control: 'dyc/config/cfc/unite/deleteImportTemplate'
  },
  // 公用应用-导入模版新增API
  common_addImportTemplate: {
    // mock: true,
    control: 'dyc/config/cfc/unite/addImportTemplate'
  },
  // 公用应用-导入模版修改API
  common_operImportTemplate: {
    // mock: true,
    control: 'dyc/config/cfc/unite/operImportTemplate'
  },
  // 公用应用-导入模版详情查询API
  common_qryImportTemplateDetail: {
    // mock: true,
    control: 'dyc/config/cfc/unite/qryImportTemplateDetail'
  },
  // 公用应用-打印模版列表查询API
  common_qryPrintingTemplateList: {
    // mock: true,
    control: 'dyc/config/cfc/unite/qryPrintingTemplateList'
  },
  // 公用应用-打印模版修改API
  common_operPrintingTemplate: {
    // mock: true,
    control: 'dyc/config/cfc/unite/operPrintingTemplate'
  },
  // 公用应用-评价模板列表API
  common_qryTemplateList: {
    // mock: true,
    control: 'dyc/busicommon/evaluate/qryTemplateList'
  },
  // 公用应用-评价模板列表API-模板类型
  common_qryTypeList: {
    // mock: true,
    control: 'dyc/busicommon/evaluate/qryTypeList'
  },
  // 公用应用-评价模板数据修改
  common_templateOperate: {
    // mock: true,
    control: 'dyc/busicommon/evaluate/templateOperate'
  },
  // 公用应用-评价模板类型新增
  common_createType: {
    // mock: true,
    control: 'dyc/busicommon/evaluate/createType'
  },
  // 公用应用-评价模板详情查询
  common_qryTemplateDetail: {
    // mock: true,
    control: 'dyc/busicommon/evaluate/qryTemplateDetail'
  },
  // 文件模板上传
  common_downloadUpload: {
    // mock: true,
    control: 'fileDownloadPlatform/fileTemplate/upload'
  },
  // 公用应用-供应商模版停启用API
  common_operSupplierTemplateStartAndStop: {
    // mock: true,
    control: 'dyc/config/cfc/unite/operSupplierTemplateStartAndStop'
  },
  // 公用应用-供应商模版列表查询API
  common_qrySupplierTemplateList: {
    // mock: true,
    control: 'dyc/config/cfc/unite/qrySupplierTemplateList'
  },
  // 公共应用-品类与资质映射列表查询API
  common_queryMappingList: {
    // mock: true,
    control: 'dyc/saas/common/user/queryMappingList'
  },
  // 公共应用-品类与资质映射新增API
  common_addMapping: {
    // mock: true,
    control: 'dyc/saas/common/user/addMapping'
  },
  // 公共应用-品类与资质映射修改API
  common_updateMapping: {
    // mock: true,
    control: 'dyc/saas/common/user/updateMapping'
  },
  // 公共应用-品类与资质映射删除API
  common_deleteMapping: {
    // mock: true,
    control: 'dyc/saas/common/user/deleteMapping'
  },
  // 公用应用-供应商企业查看审批情况API
  common_qrySupplierAuditLogList: {
    // mock: true,
    control: 'dyc/supplier/qrySupplierAuditLogList'
  },
  // 公用应用-返回信息停启用
  common_operRspInfoStartAndStop: {
    // mock: true,
    control: 'dyc/config/cfc/unite/operRspInfoStartAndStop'
  },
  // 公用应用-返回信息刷新
  common_operSysnRspInfo: {
    // mock: true,
    control: 'dyc/common/cfc/unite/operSysnRspInfo'
  },
  // 1menu配置中心-YD / 2menu通知中心 / 3menu失信行为通知模板 - 加载
  common_querySbrNoticeTemplateList: {
    // mock: true,
    control: 'dyc/saas/supplier/querySbrNoticeTemplateList'
  },
  // 供应商管理  企业基本信息修改
  common_checkSupplierInfoChangeStatus: {
    // mock: true,
    control: 'dyc/supplier/checkSupplierInfoChangeStatus'
  },
  // 公用应用-公共字典维护API
  common_dealOrgPublicDicConfig: {
    // mock: true,
    control: 'dyc/saas/common/user/dic/dealOrgPublicDicConfig'
  },
  // 配置中心-评价模板编号
  common_createConfigCode: {
    // mock: true,
    control: 'dyc/busicommon/evaluate/createConfigCode'
  }
};